(ns portal.agency-selection-page.db
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def valid-agency? pos-int?)
(def valid-advertiser? pos-int?)

(spec/def ::agency valid-agency?)
(spec/def ::advertiser valid-advertiser?)
(spec/def ::default-agency? boolean?)

(spec/def ::value
  (spec/keys :req-un [::agency ::advertiser ::default-agency?]))

(p/defphraser valid-agency?
  [_ problem]
  {:message "Select the agency for this session"
   :in (:in problem)
   :problem problem})

(p/defphraser valid-advertiser?
  [_ problem key]
  {:message "Select the advertiser for this session"
   :in (:in problem)
   :problem problem})

(def initial-value {:agency nil :advertiser nil :default-agency? false})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.agency-selection ::value)))

(form/register-form {:namespace :form.agency-selection
                     :validate-form validate-form
                     :initial-value initial-value
                     :submit-event :form.agency-selection/submit-form})

(rf/reg-event-fx :form.agency-selection/init-form
  [(rf/inject-cofx :sub :resource.user/agency-id)
   (rf/inject-cofx :localstorage ["last-viewed-advertiser-id"])]
  (fn [{:keys [db resource.user/agency-id]
        :localstorage/keys [last-viewed-advertiser-id]} _]
    {:db (-> db
             (assoc-in [:form.agency-selection :value :agency] agency-id)
             (assoc-in [:form.agency-selection :value :advertiser] last-viewed-advertiser-id))
     :dispatch [:form.agency-selection/init]}))

(rf/reg-event-fx :form.agency-selection/submit-form
  (fn [_ [_ {:keys [agency default-agency? advertiser]}]]
    {:fx [(when default-agency?
            [:localstorage/save ["default-agency" agency]])
          [:localstorage/save ["last-viewed-advertiser-id" advertiser]]
          [:router/navigate! [:advertiser/page {:params {:agency-id agency
                                                         :advertiser-id advertiser}}]]]}))

(def use-error-message (partial form/use-error-message :form.agency-selection))
(def use-bind-control (partial form/use-bind-control :form.agency-selection))

(rf/reg-sub :form.agency-selection/agencies
  :<- [:resource.user/roles]
  (fn [roles _]
    (for [r roles]
      {:label (str (:agencyName r) " (" (:roleName r) ")")
       :value (:agencyId r)})))
